function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("polyline", {
  className: "st0",
  points: "11,31 11,10 21,10 21,31 "
});

var _ref4 = /*#__PURE__*/React.createElement("polyline", {
  className: "st0",
  points: "21,31 21,16 30,16 30,31 "
});

var _ref5 = /*#__PURE__*/React.createElement("polyline", {
  className: "st0",
  points: "2,31 2,21 11,21 11,31 "
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 12,
  y: 7,
  className: "st0",
  width: 8,
  height: 3
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 14,
  y: 4,
  className: "st0",
  width: 4,
  height: 3
});

var _ref8 = /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 16,
  y1: 1,
  x2: 16,
  y2: 4
});

var _ref9 = /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 14,
  y1: 14,
  x2: 18,
  y2: 14
});

var _ref10 = /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 3,
  y1: 25,
  x2: 7,
  y2: 25
});

var _ref11 = /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 3,
  y1: 29,
  x2: 7,
  y2: 29
});

var _ref12 = /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 14,
  y1: 18,
  x2: 18,
  y2: 18
});

var _ref13 = /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 14,
  y1: 22,
  x2: 18,
  y2: 22
});

var _ref14 = /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 14,
  y1: 26,
  x2: 18,
  y2: 26
});

var _ref15 = /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 14,
  y1: 30,
  x2: 18,
  y2: 30
});

var _ref16 = /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 24,
  y1: 20,
  x2: 24,
  y2: 21
});

var _ref17 = /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 27,
  y1: 20,
  x2: 27,
  y2: 21
});

var _ref18 = /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 24,
  y1: 24,
  x2: 24,
  y2: 25
});

var _ref19 = /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 27,
  y1: 24,
  x2: 27,
  y2: 25
});

var _ref20 = /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 24,
  y1: 28,
  x2: 24,
  y2: 29
});

var _ref21 = /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 27,
  y1: 28,
  x2: 27,
  y2: 29
});

var SvgBuilding = function SvgBuilding(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBuilding, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/building.60bb5b73.svg";
export { ForwardRef as ReactComponent };